import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION28: PdfComponent = {
  type: 'section',
  id: 's28',
  title: '28. Assignment',
  content: [
    {
      type: 'bulletList',
      id: 's28bullets',
      bulletType: 'number',
      content: [
        {
          copy: 'Save as provided in clauses 28.2 and 28.4, neither party may assign, novate, transfer, charge, create a trust over, or otherwise deal in this Agreement or any of its rights or obligations under it (or purport to do so) without the prior written consent of the other. Any purported assignment in breach of this clause shall not confer any rights on the purported assignee.',
        },
        {
          copy: 'Kanda may assign this Agreement or any of its rights under it, or by novation transfer the benefit and burden of this Agreement or any of its rights and obligations under it, to any of its Affiliates, provided that:',
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: 'the Affiliate agrees to be bound by the terms of this Agreement; and',
              },
              {
                copy: 'the Liability of the Subscriber under this Agreement will continue to be subject to the same limitations, exceptions and exclusions and shall not be increased by reason of the novation or assignment.',
              },
            ],
          },
        },
        {
          copy: 'Kanda shall give the Subscriber reasonable notice of its intention to assign or novate this Agreement.',
        },
        {
          copy: "The Subscriber may, subject to Kanda's written consent (such consent not to be unreasonably withheld or delayed), assign this Agreement or any of its rights under it, or by novation transfer the benefit and burden of this Agreement or any of its rights and obligations under it, to any of its Affiliates, provided that:",
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: 'the Affiliate agrees to be bound by the terms of this Agreement; and',
              },
              {
                copy: 'the Liability of Kanda under this Agreement will continue to be subject to the same limitations, exceptions and exclusions and shall not be increased by reason of the novation or assignment.',
              },
            ],
          },
        },
        {
          copy: 'This Agreement is binding on the parties and their respective successors and permitted assignees.',
        },
      ],
      prefix: '28',
    },
  ],
};
